import { DatePicker } from '@/src/shadComponents/ui/DatePicker';

export default function DatePickerField({
    date,
    onChange,
    ...props
}: {
    date: Date;
    onChange: (value: Date) => void;
}) {
    return (
        <DatePicker
            {...props}
            date={date}
            setDate={(value: Date) => {
                onChange(value);
            }}
        />
    );
}
